import VueCookies from 'vue-cookies'
import database from './data.js'
import api from '../api/api.js'

const userUtils = {
	/* 刷新用户信息 */
	refresh(cb) {
		api.post('uCenter',{},false).then((res)=>{
			database.local.set('user',res.resultData);
			if(cb) {
				cb(res.resultData);
			}
		}).catch((err)=>{
			console.log(err);
		});
	},
	/* 判断是否登录 */
    login() {
    	if(VueCookies.get('is-login') && VueCookies.get('is-login') == 'true') {
    		return true;
    	}else {
    		return false;
    	}
    },
	/* 获取用户信息 */
	info() {
		return database.local.user();
	},
	/* 注销 */
	logout(callback){
        api.post('logout',{}).then((res)=>{
            console.log("had logout...");
            VueCookies.remove('is-login');
            VueCookies.remove('sid');
            database.session.remove('sid');
            database.session.remove('user_name');
            database.local.remove('user');
            database.local.remove('company');
            database.local.remove('warehouseList');
            if(callback) {
                callback(res.resultData);
            }
        }).catch((err)=>{
            console.log(err);
            callback(err);
        });

	},
    refreshIntegral(cb) {
        api.post('getUserIntegral',{},false).then((res)=>{
        	let user = database.local.user();
            user.integral = res.resultData.integral;
            database.local.set('user',user);
            if(cb) {
                cb(res.resultData);
            }
        }).catch((err)=>{
            console.log(err);
        });
    },
};
export default userUtils



// WEBPACK FOOTER //
// ./src/utils/user.js